/* Novyice motion layer. Pure enhancement: if this file fails, the page is fully visible and usable. */
(() => {
  const root = document.documentElement;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;
  root.classList.add('lux-motion');
  window.__luxReady = true;

  /* Safety net: whatever happens, nothing stays hidden for long. */
  const revealAll = () => {
    document.querySelectorAll('.lux-hero').forEach((h) => h.classList.add('is-in'));
    document.querySelectorAll('.card__img, .gallery__img, .tile img').forEach((i) => i.classList.add('is-loaded'));
  };
  setTimeout(revealAll, 3500);

  /* Photos fade in once decoded. */
  const markLoaded = (img) => {
    if (img.dataset.luxImg) return;
    img.dataset.luxImg = '1';
    const done = () => img.classList.add('is-loaded');
    if (img.complete && img.naturalWidth) done();
    else { img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true }); }
  };
  const scanImgs = (scope) => scope.querySelectorAll && scope.querySelectorAll('.card__img, .gallery__img, .tile img').forEach(markLoaded);

  /* Section titles: wrap each word so it can rise out of a mask. */
  const splitTitle = (el) => {
    if (el.dataset.luxSplit || el.children.length) return;
    el.dataset.luxSplit = '1';
    const words = el.textContent.trim().split(/\s+/);
    el.setAttribute('aria-label', el.textContent.trim());
    el.innerHTML = words.map((w, i) => `<span class="lux-w" aria-hidden="true"><span style="--w:${i}">${w.replace(/[&<>]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]))}</span></span>`).join(' ');
  };
  const scan = (scope) => {
    scanImgs(scope);
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll('.reveal .section__head .h2, .reveal > .container > .h2, .reveal .h2:first-child').forEach(splitTitle);
    scope.querySelectorAll('.reveal .grid').forEach((g) => [...g.children].forEach((li, n) => li.style.setProperty('--n', n % 8)));
  };
  scan(document);
  new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => n.nodeType === 1 && scan(n))))
    .observe(document.body, { childList: true, subtree: true });

  /* Hero: intro on load, then scroll-linked depth. */
  const hero = document.querySelector('[data-lux-hero]');
  if (hero) {
    const stage = hero.querySelector('.lux-hero__stage');
    requestAnimationFrame(() => requestAnimationFrame(() => hero.classList.add('is-in')));
    let ticking = false;
    const update = () => {
      ticking = false;
      const r = hero.getBoundingClientRect();
      const span = Math.max(1, r.height - stage.offsetHeight);
      const p = Math.min(1, Math.max(0, -r.top / span));
      stage.style.setProperty('--p', p.toFixed(4));
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
    /* The hero button glides to the products. */
    const next = hero.closest('.shopify-section') && hero.closest('.shopify-section').nextElementSibling;
    if (next && !next.id) next.id = 'shop';
    const cta = hero.querySelector('[data-lux-scroll]');
    if (cta && cta.getAttribute('href') === '#shop' && next) {
      cta.addEventListener('click', (e) => { e.preventDefault(); next.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    }
  }

  /* Header gets a shadow once the page moves. */
  const onS = () => root.classList.toggle('lux-scrolled', window.scrollY > 8);
  window.addEventListener('scroll', onS, { passive: true }); onS();

  /* Product photo morphs from the card into the product page (browsers with cross-page view transitions). */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('.card a[href]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    document.querySelectorAll('[style*="view-transition-name"]').forEach((el) => { el.style.viewTransitionName = ''; });
    const img = a.closest('.card').querySelector('.card__img');
    if (img) img.style.viewTransitionName = 'lux-photo';
  });
  /* Coming back with the back button: don't leave a stale name behind. */
  window.addEventListener('pageshow', () => document.querySelectorAll('.card__img[style*="view-transition-name"]').forEach((el) => { el.style.viewTransitionName = ''; }));

  /* Cart icon bump on add. */
  document.addEventListener('cart:updated', () => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      const t = el.parentElement || el; t.classList.remove('lux-bump'); void t.offsetWidth; t.classList.add('lux-bump');
    });
  });
})();
